import React from 'react'

// Ein Punkt der Fussleiste ist ein Knopf mit Namen (#178): Nummer, Gesamtzahl,
// Zustand. Erreichbar ist er nur, wenn die Frage davor beantwortet ist — die
// Regel von vorher, jetzt als disabled statt als stiller Klick ins Leere.
const SliderDot = ({ index, order, userAnswers, onClickDot }) => {
    const vorgaengerin = 0 === index ? order[index] : order[index - 1]
    const erreichbar = null !== userAnswers[vorgaengerin]
    const beantwortet = null !== userAnswers[order[index]]

    return (
        <button
            type="button"
            className={'jm-slide-dot' + (beantwortet ? ' answered' : '')}
            aria-label={`Frage ${index + 1} von ${order.length}, ${beantwortet ? 'beantwortet' : 'offen'}`}
            disabled={!erreichbar}
            onClick={() => onClickDot(index)}
        />
    )
}

export default SliderDot
